function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "676px",
    height: "352px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#db5126",
    d: "M 312.5,97.5 C 324.862,91.3228 336.862,84.6562 348.5,77.5C 360.559,97.9411 372.392,118.608 384,139.5C 405.878,71.1335 452.712,34.8002 524.5,30.5C 581.362,33.3336 624.862,58.6669 655,106.5C 668.217,130.582 673.217,156.249 670,183.5C 663.661,245.478 631.828,288.311 574.5,312C 515.917,330.31 464.417,318.477 420,276.5C 414.667,269.833 409.333,263.167 404,256.5C 373.488,203.473 342.988,150.473 312.5,97.5 Z M 514.5,71.5 C 558.795,69.7265 592.295,87.7265 615,125.5C 631.161,155.315 632.828,185.982 620,217.5C 597.875,261.566 562.041,282.066 512.5,279C 468.751,271.922 439.584,247.422 425,205.5C 414.362,162.54 425.195,126.04 457.5,96C 474.254,82.4753 493.254,74.3086 514.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#b1a6a6",
    d: "M 348.5,77.5 C 336.862,84.6562 324.862,91.3228 312.5,97.5C 295.35,75.5025 273.017,67.6692 245.5,74C 219.919,81.6455 206.086,98.8122 204,125.5C 203.5,189.166 203.333,252.832 203.5,316.5C 189.5,316.5 175.5,316.5 161.5,316.5C 161.983,248.796 161.483,181.13 160,113.5C 151.17,86.3124 132.337,72.6458 103.5,72.5C 74.2085,72.6454 55.3752,86.6454 47,114.5C 45.5205,181.802 45.0205,249.135 45.5,316.5C 31.5,316.5 17.5,316.5 3.5,316.5C 3.03054,247.811 3.53054,179.144 5,110.5C 16.2126,63.2943 46.046,37.4609 94.5,33C 120.889,30.5962 144.889,36.9296 166.5,52C 172.366,57.5313 177.866,63.3647 183,69.5C 206.625,42.6185 236.459,30.4518 272.5,33C 298.537,34.9383 320.704,45.1049 339,63.5C 342.929,67.7052 346.096,72.3719 348.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#b0a7a6",
    d: "M 320.5,141.5 C 322.074,141.937 323.241,142.937 324,144.5C 336.667,166.5 349.333,188.5 362,210.5C 362.5,246.165 362.667,281.832 362.5,317.5C 348.5,317.5 334.5,317.5 320.5,317.5C 320.5,258.833 320.5,200.167 320.5,141.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight);
export default __webpack_public_path__ + "static/media/icon-light.d27db2121fbac180d230b2b12b4197e1.svg";
export { ForwardRef as ReactComponent };